import { observer } from 'mobx-react';
import React, { Component } from 'react';
import { Helmet } from 'react-helmet-async';
import { Route, Switch } from 'react-router-dom';
import MyAppPool from '../AppPool';
import { lng } from '../ulanguages/language';
import { convertDataToShowable, getImgAddress, getRouteParamAtIndex, getSiteShortName } from '../util/text';
import { companyFastResourceType, contentTypeToFastType, isSet } from '../util/typeu';
import BannerReaction from '../view_component/BannerReaction';
import BreadCumbs from '../view_component/BreadCumbs';
import CapaSection from '../view_component/CapaSection';
import Erro404 from '../view_component/Erro404';
import SkeletonBlock from '../view_component/SkeletonBlock';
import SubNavigation from '../view_component/SubNavigation';
import TextContentBox from '../view_component/TextContentBox';
import { isMobile } from './../util/mobile';
import { getCurrentUrl, isServer } from './../util/windowUtil';
import CSSTransition2 from './../view_component/CSSTransition2';
import CompanyGeralView from './companysub/CompanyGeralView';
import CompanyReviewView from './companysub/CompanyReviewView';
import ContentBannerSetter from '../view_component/ContentBannerSetter';
import { serverRegisterFetch } from '../util/updateManager';
import ResourceMediaView from "./resourceMedia";
import Capa from './../view_component/Capa';
import CycleBanner from '../view_component/CycleBanner';
import { getObraRoute } from '../store/AppRoutes';
import ForumThreadsByTagBox from '../view_component/ForumThreadsByTagBox';
import NewsByTagSubPage from './newsByTagSubPage';

function vhToPixels (vh) {
  if (!isServer())
    return Math.round(window.innerHeight / (100 / vh)) + 'px';
  return '1080px';
}

@observer
class Company extends Component {
  constructor(props)
  {
    super(props);
    this.state={currentCompany:-1}
    serverRegisterFetch(Company.getInitialValues);
  }
  componentDidMount()
  {
    Company.getInitialValues();
  }
  static async getInitialValues()
  {
    let companyid = getRouteParamAtIndex(getCurrentUrl(),2);
    //console.log("COMPANY::::",companyid);
    if (isSet(companyid) || companyid===0)
    {
      //console.log("COMPANY FETCH::::",companyid);
      let p1 = MyAppPool.cCompany.fetchCompanyById(companyid);
      let p2 = MyAppPool.cReview.fetchReviews(contentTypeToFastType('producer'),companyid);
      let p3 = MyAppPool.cReactionPosts.fetchReactionPosts(contentTypeToFastType('producer'),companyid);
      let p4 = MyAppPool.cResourceMedia.getResourceMedia(companyFastResourceType,companyid);
      await Promise.all([p1,p2,p3,p4]);
    }
    return Promise.resolve();
  }
  componentWillReceiveProps()
  {
    let companyid = getRouteParamAtIndex(getCurrentUrl(),2);
    let {currentCompany}= this.state;
    if (currentCompany!==companyid)
    {
      this.setState({currentCompany:companyid});
      Company.getInitialValues();
    }
  }

  render(){
    let companyid = getRouteParamAtIndex(getCurrentUrl(),2);
    if (isNaN(Number(companyid)))
      return <Erro404 />;
    if (MyAppPool.session.companyFetchEmpty[companyid]===true)
      return <Erro404/>;

    let current = MyAppPool.cCompany.currentCompany;
    let tabBaseUrl = current.baseUrl;
    let tabs = [
      {name:lng('Geral'),url:tabBaseUrl},
      {name:'Media',url:tabBaseUrl+'/'+'media'},
      {name:lng('News'),url:tabBaseUrl+'/'+lng('News')},
      {name:lng('Reviews'),url:tabBaseUrl+'/'+lng('reviews')},
    ];
    

    if (current.ready)
    {
        let resourceType = companyFastResourceType;
        let reviews = MyAppPool.session.review[resourceType][current.id];
        let reviewsSize=0;
        if (typeof reviews !=='undefined')
          reviewsSize=reviews.length;
      if (reviewsSize<=0)
        tabs = tabs.filter(e=>e.name!==lng('Reviews'));
    }

    let lists = [];
    let listPresence = [];
    let reactionPosts = [];
    let reactionReady = 0;
    let resourceType = contentTypeToFastType('producer');
    if (current.ready)
    {
      reactionPosts = MyAppPool.session.reactionPost[resourceType][current.id];
      if (typeof reactionPosts ==='undefined')
        {
          reactionPosts=[];
          reactionReady = 0;
        }else
          reactionReady = 1;
        lists = MyAppPool.session.user.lists[resourceType];
        listPresence = MyAppPool.cLists.getListPresence(resourceType,current.id);
        if (!Array.isArray(lists))
          lists = [];
    }
    
    
    let meta = {title:lng('Empresa')+' | '+getSiteShortName()+'',desc:'',img:'',imgwidth:'',imgheight:'',imgtype:'',keywords:''};
    let bannerImages = [];
    if (current.ready)
    {
      let desc = current.description || '';
      meta =  {
        title:current.name +' - ' + lng('Empresa') + ' | '+getSiteShortName()+'',
        desc:desc,
        keywords:current.name +  ', ' + current.otherTitles +', ' +current.remainingTitles,
        img:getImgAddress(current.mainimg),
        imgwidth:'225',
        imgheight:'338',
        imgtype:'jpg'
      };
      for(let i=0;i<current.related.length;i++)
      {
          let anime = current.related[i];
          if (isSet(anime.bannerimg) && anime.bannerimg.length>0)
          {
            bannerImages.push({image:getImgAddress(anime.bannerimg), url:getObraRoute(anime.id,anime.title,'anime')+'#top'});
          }
      }
    }
    let baseImage = "random:sky";
    if (bannerImages.length>0)
      baseImage = "component:"+bannerImages.length;

    if (current.empty)
      return <Erro404/>;
  
      return (
        <div>
          <Helmet>
            <title>{meta.title}</title>
            <meta name="title" content={meta.title} />
            <meta name="description" content={meta.desc} />
            <meta name="keywords" content={meta.keywords}/>
            <meta property="og:type" content="website" />
            <meta property="og:title" content={meta.title} />
            <meta property="og:description" content={meta.desc} />
            <meta name="twitter:title" content={meta.title}/>
            <meta name="twitter:description" content={meta.desc}/>
            <meta name="twitter:image:src" content={getImgAddress(meta.img)}/>
            <meta property="og:image" content={getImgAddress(meta.img)} />
            <meta property="og:image:type" content={meta.imgtype}/>
            <meta property="og:image:width" content={meta.imgwidth}/>
            <meta property="og:image:height" content={meta.imgheight}/> 
          </Helmet>
        <div className="contentpage">
        <ContentBannerSetter images={[baseImage]} modes = {["component"]} component=
        {<CycleBanner images={bannerImages}/>}   />
          <div>
          {!isMobile.any?
          <div style={{position:'relative'}}>
            <div className="reactions">
              <BannerReaction
                items ={reactionPosts}
                ready={reactionReady}
              />
            </div>
          </div>
          : <></>}
          </div>
          <div className='uk-flex uk-flex-row topsection'>
            {!isMobile.any?
            <div className="capa_left_column">
            <Capa ready={current.ready} img={current.mainimg}/>
            <CapaSection ready={current.ready} img={getImgAddress(current.mainimg,'/imgs/defaults/company.webp')}
            resourceType={contentTypeToFastType('producer')}
            resourceId={current.id}
            lists={lists}
            listsPresence ={listPresence}
            gradeable={true}
            /> </div>
            :<></>
            }
            <div className="contentInfo">
            {isMobile.any?
            <div style={{"width":"100%"}}>
            <Capa ready={current.ready} img={current.mainimg}/>
            <CapaSection ready={current.ready} img={current.mainimg} 
            resourceType={contentTypeToFastType('producer')}
            resourceId={current.id}
            lists={lists}
            listsPresence ={listPresence}
            gradeable={true} /> </div>
            :<></>
            }
              <BreadCumbs/>
              {current.ready ?
               <>
                <h1 className="smallerheading"> <span id='title'>{current.name} &nbsp;</span>
                </h1>
                <h2 className="smallerheading2"> {current.otherTitles}</h2>
                {current.description===''? <span>{lng('Sem informações a mostrar')}</span>
                :
                <TextContentBox content={current.description}/>}
                </>
                :<>
                <SkeletonBlock style={{'width':'250px',height:'50px', 'marginTop':'8px'}}/>
                <SkeletonBlock style={{'width':'300px',height:'25px', 'marginTop':'8px'}}/>
                <SkeletonBlock style={{'width':'95%',height:'150px', 'marginTop':'15px'}}/>
                <SkeletonBlock style={{'width':'250px',height:'30px', 'marginTop':'15px'}}/>
                <SkeletonBlock style={{'width':'350px',height:'30px', 'marginTop':'15px'}}/>
                </>
                }
                </div>
          </div>
          
          <div className="naveg" data-uk-sticky="offset: 0">
            <div className = "uk-flex uk-flex-row"> 
            <SubNavigation items={tabs}/> 
            {!isMobile.any?
            <button aria-label={lng('MAB por MaxBrasi')} className="link-button tinylink">{lng('MAB por MaxBrasi')}</button>
            :<></>}
            </div>
            {isMobile.any?
            <button aria-label={lng('MAB por MaxBrasi')} className="link-button tinylink">{lng('MAB por MaxBrasi')}</button>
            :<></>}
          </div>

          <div className="authortag">
                    </div>
          {//!isMobile.any?
          //:<></>
        }
          
          
          <Route render={({ location }) => {
            const { pathname, key } = location;
            return (
              <div style={{position:'relative'}}>
                <CSSTransition2
                  in={true}
                  key={key}
                  classNames="switch-node"
                  timeout={{enter: 750, exit: 0}}
                >
                  <div>
                  <Switch>
                    <Route path={'/'+lng('empresa')+'/:aid/:aname'} exact={true}>
                      <CompanyGeralView current={current}/>
                    </Route>
                    <Route path={'/'+lng('empresa')+'/:aid/:aname/'+'media'}>
                      <ResourceMediaView resourceType={companyFastResourceType} resourceId={current.id}/> 
                    </Route>
                    <Route path={'/'+lng('empresa')+'/:aid/:aname/'+lng('reviews')} exact={true}>
                      <CompanyReviewView current={current}/>
                    </Route>
                    <Route path={'/'+lng('empresa')+'/:aid/:aname/'+lng('News')} exact={true}>
                      <NewsByTagSubPage tag={"lnkres_"+companyFastResourceType+"_"+companyid}/>
                    </Route>
                    
                    <Route path="*" render={() => <Erro404 />} />
                  </Switch>
                  </div>
                </CSSTransition2>
              </div>
          )
        }}/>

        </div>
        </div>
      );

}
}

export default Company;
